import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Pagination from 'react-bootstrap/Pagination';
import Spinner from 'react-bootstrap/Spinner'; // Added for loading spinner
import styles from '../../CSS/KitchenPrinterList.module.css';

const KitchenPrinterList = () => {
  const navigate = useNavigate();
  const [devices, setDevices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false); // Loading state
  const limit = 10;

  const fetchDevices = async (page) => {
    try {
      setLoading(true); // Start loading
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/devices/type/Kitchen%20Printer?page=${page}&limit=${limit}`
      );
      if (response.ok) {
        const data = await response.json();
        setDevices(data.devices);
        setTotalPages(data.totalPages);
        setCurrentPage(data.currentPage);
      } else {
        console.error("Failed to fetch Kitchen Printer devices");
      }
    } catch (error) {
      console.error("Error fetching Kitchen Printer devices:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchDevices(currentPage);
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDelete = async (deviceId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this device?");
    if (confirmDelete) {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/devices/${deviceId}`, {
        method: 'DELETE'
      });
      if (response.ok) {
        fetchDevices(currentPage);
      } else {
        alert('Failed to delete the device');
      }
    }
  };

  return (
    <div className={styles.container}>
      <h2>Kitchen Printer Devices</h2>
      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" role="status" />
          <div>Loading...</div>
        </div>
      ) : devices.length === 0 ? (
        <div className="text-center my-5">
          <p>No devices found.</p>
        </div>
      ) : (
        <>
          <table className={`table table-responsive ${styles.table}`}>
            <thead>
              <tr>
                <th>#</th>
                <th>Friendly Name</th>
                <th>Name</th>
                <th>Pier</th>
                <th>IP</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {devices.map((device, index) => (
                <tr key={device._id}>
                  <td>{(currentPage - 1) * limit + index + 1}</td>
                  <td>
                    <Link to={`/it/device/${device._id}`}>{device.friendlyName}</Link>
                  </td>
                  <td>{device.name}</td>
                  <td>{device.pier}</td>
                  <td>{device.ip}</td>
                  <td>
                    <span className={`badge ${device.isOnline ? 'bg-success' : 'bg-danger'} ${styles.badge}`}>
                      {device.isOnline ? 'Online' : 'Offline'}
                    </span>
                  </td>
                  <td>
                    <button onClick={() => navigate(`/it/device/edit/${device._id}`)} className={`btn btn-primary ${styles.btn}`}>
                      Edit
                    </button>
                    <button onClick={() => handleDelete(device._id)} className={`btn btn-danger ${styles.btn}`}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination className="justify-content-center mt-4">
            {Array.from({ length: totalPages }, (_, index) => (
              <Pagination.Item
                key={index + 1}
                active={index + 1 === currentPage}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </>
      )}
    </div>
  );
};

export default KitchenPrinterList;